export const APP_BAR_HEIGHT = 72;
export const APP_BAR_DESKTOP_HEIGHT = 96;
